module.exports = __webpack_public_path__ + "static/img/dialog-top-bg1.e9839be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dialog-top-bg1.png
// module id = sUn2
// module chunks = 0